<script setup lang="ts">
import {changeTab} from "../lib/router.ts";
</script>

<template>
  <div class="home-button">
    <div class="button1 clash-font-normal" @click="changeTab(3)">{{ $t('download') }}</div>
    <div style="width: 1dvh"></div>
    <div class="button2 clash-font-normal"  @click="changeTab(1)" ><img src="/@/assets/community.png"/></div>
  </div>
</template>

<style scoped lang="scss">

.home-button{
  padding-top: 34dvh;
  height: 18dvh;
  //background-color: #fdcf17;
  display: flex;
  flex-direction: row; // 让子元素垂直排列
  justify-content: center; // 让子元素上下居中
  align-items: center; // 让子元素左右占满
}
.button1{
  width: 30dvh;
  height: 10dvh;
  color: white;
  background-color: #f25326;
  border-radius: 15px;
  border: #2b2b2b solid 4px;
  display: flex;
  flex-direction: row; // 让子元素垂直排列
  justify-content: center; // 让子元素上下居中
  align-items: center; // 让子元素左右占满
}
.button2{
  width: 10dvh;
  height: 10dvh;
  color: white;
  background-color: #4b4b4b;
  border-radius: 15px;
  border: #2b2b2b solid 4px;
  display: flex;
  flex-direction: row; // 让子元素垂直排列
  justify-content: center; // 让子元素上下居中
  align-items: center; // 让子元素左右占满
}
</style>
